<div fxLayout="row wrap" *ngIf="!isApproval()">
    <div fxFlex.gt-lg="16" fxFlex.gt-md="16" fxFlex.gt-xs="100" fxFlex="100" *ngFor="let item of saldo">
        <mat-card>
            <mat-card-content>
                <mat-card-title>{{ item.label }}</mat-card-title>
                <mat-card-subtitle>{{ item.description }}</mat-card-subtitle>
                <span class="big-number">{{ item.total }}</span>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div fxLayout="row wrap">
    <mat-card class="full-width">
        <mat-card-content>
            <div fxLayout="row wrap" style="margin-bottom: 20px;">
                <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100" *ngIf="!isApproval()">
                    <button mat-raised-button color="primary" (click)="openDialog()">
                        Pengajuan Cuti
                    </button>
                </div>
                <div class="spacer"></div>
                <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100" class="padding-right">
                    <mat-form-field appearance="outline">
                        <mat-label>Substansi</mat-label>
                        <mat-select [formControl]="substansi" ngDefaultControl>
                            <mat-option *ngFor="let item of substansies" [value]="item.id">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100" class="padding-right">
                    <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select [formControl]="status" ngDefaultControl>
                            <mat-option *ngFor="let item of statuses" [value]="item.id">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100" class="padding-right">
                    <mat-form-field appearance="outline">
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate [formControl]="fromDate" placeholder="Mulai Tanggal">
                            <input matEndDate [formControl]="toDate" placeholder="Sampai Tanggal">
                        </mat-date-range-input>
                        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100">
                    <input matInput placeholder="Cari..." [(ngModel)]="searchTerm" class="search-field input-outline" />
                </div>

                <div fxFlex.gt-lg="8" fxFlex.gt-md="8" fxFlex.gt-xs="100" fxFlex="100">
                    <button mat-raised-button color="primary" (click)="search()">
                        Cari
                    </button>
                </div>
            </div>
            <div fxLayout="row wrap" *ngIf="dataSource.length === 0 && !isLoading" class="center-col">Tidak ada
                pengajuan cuti</div>
            <div fxLayout="row wrap">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                <table mat-table [dataSource]="dataSource" class="full-width">
                    <ng-container matColumnDef="nomor">
                        <th mat-header-cell *matHeaderCellDef>Nomor</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.nomor }}
                            <div class="row" *ngIf="!isLoading && isDraft(element) && !isApproval()">
                                <button mat-raised-button class="mat-button-small" color="warn" matTooltip="Ajukan"
                                    matTooltipPosition="above" (click)="submit(element)"
                                    *ngIf="!isLoading && isDraft(element) && !isApproval()">
                                    Ajukan
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nama">
                        <th mat-header-cell *matHeaderCellDef>Pegawai</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.user.fullname }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="jenis">
                        <th mat-header-cell *matHeaderCellDef>Jenis Cuti</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.jenis.name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="durasi">
                        <th mat-header-cell *matHeaderCellDef>Lamanya Cuti</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">{{ element.jumlahHari }}</td>
                    </ng-container>

                    <ng-container matColumnDef="tanggal">
                        <th mat-header-cell *matHeaderCellDef>Tanggal</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.tanggal }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            <mat-chip-list>
                                <mat-chip color="accent" selected="true">
                                    <span class="status-chip">{{ element.status.name }}</span>
                                </mat-chip>
                            </mat-chip-list>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="atasan">
                        <th mat-header-cell *matHeaderCellDef>Atasan</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.atasanName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pejabat">
                        <th mat-header-cell *matHeaderCellDef>Pejabat</th>
                        <td mat-cell *matCellDef="let element" class="cell-padding">
                            {{ element.pejabatName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Aksi</th>
                        <td mat-cell *matCellDef="let element">
                            <div fxLayout="row wrap">
                                <app-approval *ngIf="isWaitingAtasan(element) && isUserMatched(element, false)"
                                    [cutiId]="element.id" [isPejabat]="false">
                                </app-approval>
                                <app-approval *ngIf="isWaitingPejabat(element) && isUserMatched(element, true)"
                                    [cutiId]="element.id" [isPejabat]="true">
                                </app-approval>
                            </div>
                            <div fxLayout="row">
                                <button mat-icon-button *ngIf="element.attachments && element.attachments.length > 0"
                                    class="action-button" matTooltip="Preview" matTooltipPosition="above"
                                    (click)="preview('', downloadService.downloadUrl(2, element.attachments[0].realFile!))">
                                    <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <button mat-icon-button class="action-button"
                                    (click)="confirmCancelationDialog(element)" matTooltip="Anulir"
                                    matTooltipPosition="above"
                                    *ngIf="!isLoading && isPengajuan(element) && !isApproval() && isUserPengajuanMatched(element)">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                                <button mat-icon-button class="action-button" (click)="openDialog(element)"
                                    matTooltip="Ubah" matTooltipPosition="above"
                                    *ngIf="!isLoading && (tokenStorageService.isSuperadmin() || (isDraft(element) && !isApproval()))">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button class="action-button" matTooltip="Cetak"
                                    matTooltipPosition="above" (click)="print(element)">
                                    <mat-icon>print</mat-icon>
                                </button>
                                <button mat-icon-button class="action-button" matTooltip="Informasi"
                                    matTooltipPosition="above" (click)="openInfoDialog(element)">
                                    <mat-icon>info</mat-icon>
                                </button>
                                <button mat-icon-button class="action-button" (click)="confirmDialog(element)"
                                    matTooltip="Hapus" matTooltipPosition="above"
                                    *ngIf="!isLoading && ((isDraft(element) && !isApproval()) || (tokenStorageService.isSuperadmin() || tokenStorageService.isAdminCuti()))">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
            <div fxLayout="row wrap">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="reload($event)">
                </mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>